import React from 'react';
import VirtualServiceEducationModal from './VirtualServiceEducationModal';
import analytics from '../../../../../modules/analytics';
import { renderModalInContext } from '../../../../ui/ModalContext';
import {
  NaturalHairPrompt,
  HaircutsPrompt,
  EstheticiansPrompt,
  ColoristPrompt,
  ConsultationsPrompt,
} from './VirtualServiceEducationModalCopy';
/**
 * Open the Virtual Service modal
 */
export const openModal = (modalContext, notification) => {
  let copy = null;

  if (notification && notification.recommendation === 'Natural Styles') {
    copy = <NaturalHairPrompt />;
  } else if (notification && notification.recommendation === 'Haircut & Trim') {
    copy = <HaircutsPrompt />;
  } else if (notification && notification.recommendation === 'Makeup & Skincare') {
    copy = <EstheticiansPrompt />;
  } else if (notification && notification.recommendation === 'Color & Treatments') {
    copy = <ColoristPrompt />;
  }

  return renderModalInContext(
    closeModal => (
      <VirtualServiceEducationModal
        onCloseModal={closeModal}
        providerId={notification.provider_id}
        copy={copy || <ConsultationsPrompt />}
      />
    ),
    modalContext,
    () => analytics.track('virtual_service_education_modal_dismissed'),
  );
};

export default VirtualServiceEducationModal;
